<template>
  <div class="bg-light p-3">
    <Alert v-show="!fileCanBeImport" variant="danger" :dismissible="true">
      {{ errorMessage }}
    </Alert>
    <Alert v-show="dynamicContentsAdd" variant="success" :dismissible="true">
      {{ $t('Dynamic contents was successfully imported') }}
    </Alert>
    <Alert v-show="dynamicContentsRemove" variant="warning" :dismissible="true">
      {{ $t('Dynamic contents was successfully removed') }}
    </Alert>

    <div class="tw:flex tw:items-center">
      <input type="file" id="file" ref="file">

      <button class="btn btn-outline-secondary btn-sm ml-2"
              type="button"
              tabindex="-1"
              @click.prevent="upload">
        {{ $t('Import') }}
      </button>
    </div>


    <DeleteDynamicContents
        :url-delete="urlDelete"
        :total-dynamic-contents-display="totalDynamicContentsDisplay"
        @delete-dynamic-contents="totalDynamicContentsDisplay = 0; dynamContentTypes = {}; dynamicContentsRemove = true"
    />

    <div class="mt-2">
      <ShowDynamicContentsExample
          v-if="Object.keys(dynamContentTypes).length > 0"
          :data="dynamContentTypes"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import ShowDynamicContentsExample from "@/components/marketing-message/ShowDynamicContentsExample.vue";
import Alert from "@/components/ui/Alert.vue";
import DeleteDynamicContents from "@/components/marketing-message/DeleteDynamicContents.vue";

// Props
const props = defineProps({
  urlUpload: {
    required: true,
    type: String,
  },
  urlDelete: {
    required: true,
    type: String,
  },
  totalDynamicContents: {
    required: true,
    type: Number,
  },
  dynamicContentTypes: {
    type: Object,
    default: () => ({}),
  }
})

// Refs et variables réactives
const file = ref(null)
const totalDynamicContentsDisplay = ref(0)
const fileCanBeImport = ref(true)
const dynamContentTypes = ref({})
const errorMessage = ref('')
const dynamicContentsAdd = ref(false)
const dynamicContentsRemove = ref(false)

// Méthodes
function upload() {
  Vapor.store(file.value.files[0], {
    visibility: 'public-read',
    progress: progress => {
      // Optionnel: gérer la progression
    }
  }).then(response => {
    axios.put(props.urlUpload, {
      uuid: response.uuid,
      key: response.key,
      bucket: response.bucket,
      extension: response.extension,
      name: file.value.files[0].name,
      content_type: file.value.files[0].type,
    })
    .then(response => {
      if (response.data.error) {
        fileCanBeImport.value = false
        errorMessage.value = response.data.error
      } else {
        totalDynamicContentsDisplay.value = response.data.totalImports
        dynamContentTypes.value = response.data.importTypes
        dynamicContentsAdd.value = true
      }
    })
    .catch(error => {
      alert(error)
    })
  }).catch(error => {
    alert(error)
  });
}

// Initialisation à l'affichage
onMounted(() => {
  totalDynamicContentsDisplay.value = props.totalDynamicContents
  dynamContentTypes.value = props.dynamicContentTypes
})

// Gestion de l'événement de suppression
function handleDeleteDynamicContents() {
  totalDynamicContentsDisplay.value = 0
  dynamContentTypes.value = {}
  dynamicContentsRemove.value = true
}
</script>

<style scoped>

</style>
